<DOMContainer width="100%" height="100%" controls={menuControls}>
    <div class="rpg-ui-main-menu rpg-anim-fade-in" data-closing={transition.closing() ? "true" : "false"} click={closeMenuFromPointer}>
        <div class="rpg-ui-main-menu-backdrop"></div>
        <div class="rpg-ui-main-menu-layout" click={stopEvent}>
            @if (!saveOverlay() && !hotbarAssignmentOpen()) {
                <button class="rpg-ui-close-button" type="button" aria-label={t("rpg.ui.close")} click={closeMenuFromPointer}>×</button>
            }
            <div class="rpg-ui-main-menu-left rpg-ui-menu rpg-ui-panel">
                <div class="rpg-ui-menu-header">{t("rpg.menu.title")}</div>
                <div class="rpg-ui-main-menu-list">
                    @for ((entry,index) of menuEntries()) {
                        <div
                            class="rpg-ui-menu-item"
                            class={{disabled: isMenuDisabled(entry)}}
                            data-selected={selectedMenu() === index ? "true" : "false"}
                            tabindex={index}
                            click={selectMenu(index)}
                        >{entry.label}</div>
                    }
                </div>
            </div>
            <div class="rpg-ui-main-menu-right">
                @if (view() === "menu") {
                    <div class="rpg-ui-panel">
                        <div class="rpg-ui-dossier">
                            <div class="rpg-ui-dossier-portrait">
                                @if (heroGraphic()) {
                                    <DOMSprite sheet={heroSheet()} playing="stand" width="100px" height="110px" objectFit="contain" />
                                } @else {
                                    <span class="rpg-ui-fallback-icon" aria-hidden="true">◇</span>
                                }
                            </div>
                            <div>
                                <div class="rpg-ui-eyebrow">{t("rpg.menu.status")}</div>
                                <h1 class="rpg-ui-dossier-name">{heroName()}</h1>
                                <div class="rpg-ui-dossier-caption">{t("rpg.menu.level-value", { level: level() })}</div>
                            </div>
                        </div>
                        <div class="rpg-ui-main-menu-status-card">
                            <div class="rpg-ui-main-menu-status-block">
                                <div class="rpg-ui-main-menu-status-label">{t("rpg.menu.level")}</div>
                                <div class="rpg-ui-main-menu-status-value">{level()}</div>
                            </div>
                            <div class="rpg-ui-main-menu-status-block">
                                <div class="rpg-ui-main-menu-status-label">{t("rpg.menu.gold")}</div>
                                <div class="rpg-ui-main-menu-status-value">{gold()}</div>
                            </div>
                            <div class="rpg-ui-main-menu-status-block">
                                <div class="rpg-ui-main-menu-status-label">{t("rpg.menu.hp-value", { value: hp() ?? 0, max: hpMax() ?? 0 })}</div>
                                <div class="rpg-ui-main-menu-status-bar">
                                    <div class="rpg-ui-main-menu-status-bar-fill hp" style={{width: hpPercent}}></div>
                                </div>
                            </div>
                            <div class="rpg-ui-main-menu-status-block">
                                <div class="rpg-ui-main-menu-status-label">{t("rpg.menu.sp-value", { value: sp() ?? 0, max: spMax() ?? 0 })}</div>
                                <div class="rpg-ui-main-menu-status-bar">
                                    <div class="rpg-ui-main-menu-status-bar-fill sp" style={{width: spPercent}}></div>
                                </div>
                            </div>
                            <div class="rpg-ui-main-menu-status-block" style={{gridColumn: "span 2"}}>
                                <div class="rpg-ui-main-menu-status-label">{t("rpg.menu.exp-value", { value: exp(), max: expForNextlevel() })}</div>
                                <div class="rpg-ui-main-menu-status-bar">
                                    <div class="rpg-ui-main-menu-status-bar-fill exp" style={{width: expPercent}}></div>
                                </div>
                            </div>
                        </div>
                        <div class="rpg-ui-main-menu-section-title">{t("rpg.menu.parameters")}</div>
                        <div class="rpg-ui-main-menu-params">
                            @for ((param,index) of paramsList) {
                                <div class="rpg-ui-main-menu-param">
                                    <span>{param.label}</span>
                                    <span>{param.value}</span>
                                </div>
                            }
                        </div>
                    </div>
                }
                @if (view() === "items") {
                    <ItemsMenu
                        data={data}
                        assignmentOpen={hotbarAssignmentOpen}
                        onAssignHotbar={openHotbarAssignment}
                        onInteraction={onInteraction}
                        onBack={goBack}
                    />
                }
                @if (view() === "skills") {
                    <SkillsMenu
                        data={data}
                        assignmentOpen={hotbarAssignmentOpen}
                        onAssignHotbar={openHotbarAssignment}
                        onInteraction={onInteraction}
                        onBack={goBack}
                    />
                }
                @if (view() === "equip") {
                    <EquipMenu data={data} onInteraction={onInteraction} onBack={goBack} />
                }
                @if (view() === "options") {
                    <OptionsMenu onBack={goBack} />
                }
                @if (view() === "exit") {
                    <ExitMenu onConfirm={confirmExit} onBack={goBack} />
                }
            </div>
        </div>
        @if (hotbarAssignmentOpen()) {
            <HotbarSlotPicker
                hotbar={menuHotbar}
                entry={hotbarAssignmentEntry}
                onAssign={assignHotbarSlot}
                onClear={clearHotbarSlot}
                onCancel={closeHotbarAssignment}
            />
        }
        @if (saveOverlay) {
            <div class="rpg-ui-main-menu-overlay">
                <div class="rpg-ui-main-menu-overlay-backdrop" click={closeSaveOverlayFromPointer}></div>
                <div class="rpg-ui-main-menu-overlay-content" click={stopEvent}>
                    <SaveLoadComponent
                        data={saveLoadData}
                        onFinish={closeSaveOverlay}
                    />
                </div>
            </div>
        }
    </div>
</DOMContainer>

<script>
    import { signal, computed, effect, mount } from "canvasengine";
    import { inject } from "../../../core/inject";
    import { RpgClientEngine } from "../../../RpgClientEngine";
    import SaveLoadComponent from "../save-load.ce";
    import ItemsMenu from "./items-menu.ce";
    import SkillsMenu from "./skills-menu.ce";
    import EquipMenu from "./equip-menu.ce";
    import OptionsMenu from "./options-menu.ce";
    import ExitMenu from "./exit-menu.ce";
    import HotbarSlotPicker from "./hotbar-slot-picker.ce";
    import { getEntityProp } from "../../../utils/getEntityProp";
    import { delay, Direction } from "@rpgjs/common";
    import { getKeyboardControlBind } from "../../../services/actionInput";
    import { menuGamepadControls } from "../../../services/gamepadControls";

    import { movementPreferences, refreshKeyboardBindings } from "../../../services/movementPreferences";
    import { guiTransition, lockGuiInput } from "../lifecycle";
    const engine = inject(RpgClientEngine);
    const transition = guiTransition();
    const releaseInput = lockGuiInput(engine);
    const { t } = engine.i18n();
    const currentPlayer = engine.scene.currentPlayer;
    const keyboardControls = engine.globalConfig.keyboardControls;

    const { data, onFinish, onInteraction } = defineProps();
    const { menus, items, skills, equips, saveLoad } = data();

    const defaultMenus = computed(() => [
        { id: "status", label: t("rpg.menu.status") },
        { id: "items", label: t("rpg.menu.items") },
        { id: "skills", label: t("rpg.menu.skills") },
        { id: "equip", label: t("rpg.menu.equip") },
        { id: "options", label: t("rpg.menu.options") },
        { id: "save", label: t("rpg.menu.save") },
        { id: "exit", label: t("rpg.menu.exit") }
    ]);

    const menuEntries = computed(() => {
        if (menus && Array.isArray(menus) && menus.length) return menus.map(entry => ({ ...entry, label: entry.label?.startsWith("rpg.") ? t(entry.label) : entry.label }));
        return defaultMenus();
    });

    const resolveProp = (value) => typeof value === "function" ? value() : value;
    const saveLoadData = computed(() => resolveProp(saveLoad) || {});
    const saveLoadMode = computed(() => saveLoadData().mode || "load");
    const saveLoadSlots = computed(() => saveLoadData().slots || []);
    const saveLoadCanSave = computed(() => saveLoadData().canSave !== false);

    const isMenuDisabled = (entry) => {
        if (!entry) return true;
        if (entry.disabled) return true;
        if (entry.enabled === false) return true;
        if (entry.id === "save" && !saveLoadCanSave()) return true;
        return false;
    };

    const selectedMenu = signal(0);
    const view = signal("menu");
    const saveOverlay = signal(false);
    const hotbarAssignmentEntry = signal(null);
    const hotbarAssignmentOpen = computed(() => Boolean(hotbarAssignmentEntry()));
    const menuHotbar = computed(() => resolveProp(data)?.hotbar || { slots: [] });
    const canAssignHotbarType = (type) => {
        const allowed = menuHotbar().allowedEntryTypes;
        return !Array.isArray(allowed) || allowed.includes(type);
    };

    const selectableIndexes = computed(() => {
        const entries = menuEntries();
        return entries
            .map((entry, index) => (isMenuDisabled(entry) ? null : index))
            .filter((value) => value !== null);
    });

    effect(() => {
        const available = selectableIndexes();
        if (!available.length) return;
        const current = selectedMenu();
        if (!available.includes(current)) {
            selectedMenu.set(available[0]);
        }
    });

    const moveMenu = (delta) => {
        const available = selectableIndexes();
        if (!available.length) return;
        const current = selectedMenu();
        const currentIndex = Math.max(0, available.indexOf(current));
        const nextIndex = (currentIndex + delta + available.length) % available.length;
        selectedMenu.set(available[nextIndex]);
        engine.playUiSound("navigate");
    };

    function selectMenu(index) {
        return function() {
            selectedMenu.set(index);
            engine.playUiSound("navigate");
            openMenu();
        }
    }

    const openMenu = () => {
        const entry = menuEntries()[selectedMenu()];
        if (!entry || isMenuDisabled(entry)) {
            engine.playUiSound("error");
            return;
        }
        engine.playUiSound("confirm");
        if (entry.id === "save") {
            saveOverlay.set(true);
            return;
        }
        if (entry.id === "exit") {
            view.set("exit");
            return;
        }
        view.set(entry.id === "status" ? "menu" : entry.id);
    };

    const goBack = () => {
        engine.playUiSound("cancel");
        if (hotbarAssignmentOpen()) {
            closeHotbarAssignment();
            return;
        }
        delay(() => {
            // The cursor stays on the entry the player came from.
            view.set("menu");
        });
    };

    // Entries that open a panel; "save" (overlay) and "exit" (confirmation) are not tabs.
    const tabIndexes = computed(() => selectableIndexes().filter((index) => {
        const id = menuEntries()[index]?.id;
        return id !== "save" && id !== "exit";
    }));

    const switchTab = (delta) => {
        if (saveOverlay() || hotbarAssignmentOpen() || view() === "exit") return;
        const tabs = tabIndexes();
        if (!tabs.length) return;
        const position = tabs.indexOf(selectedMenu());
        const next = tabs[(Math.max(0, position) + delta + tabs.length) % tabs.length];
        if (next === selectedMenu() && position >= 0 && tabs.length === 1) return;
        selectedMenu.set(next);
        engine.playUiSound("navigate");
        const id = menuEntries()[next].id;
        view.set(id === "status" ? "menu" : id);
    };

    const openHotbarAssignment = (entry) => {
        if (!entry?.id || !canAssignHotbarType(entry.type)) return;
        hotbarAssignmentEntry.set({
            type: entry.type || "skill",
            id: entry.id,
            name: entry.name || entry.id
        });
    };

    const closeHotbarAssignment = () => {
        // Keep the modal state active until the current CanvasEngine control
        // dispatch finishes so parent/child Escape handlers cannot both act.
        queueMicrotask(() => hotbarAssignmentEntry.set(null));
    };

    const assignHotbarSlot = (slot) => {
        const entry = hotbarAssignmentEntry();
        if (!entry) return;
        onInteraction?.("assignHotbarSlot", {
            slot,
            entry: { type: entry.type, id: entry.id }
        });
        closeHotbarAssignment();
    };

    const clearHotbarSlot = (slot) => {
        onInteraction?.("clearHotbarSlot", { slot });
        closeHotbarAssignment();
    };

    const closeSaveOverlay = () => {
        delay(() => {
            saveOverlay.set(false);
            view.set("menu");
        });
    };

    const stopEvent = (event) => {
        event?.stopPropagation?.();
    };

    const closeSaveOverlayFromPointer = (event) => {
        stopEvent(event);
        closeSaveOverlay();
    };

    const closeMenu = () => {
        if (saveOverlay()) {
            closeSaveOverlay();
            return;
        }
        engine.playUiSound("close");
        transition.finish(() => onFinish());
    };

    const closeMenuFromPointer = (event) => {
        stopEvent(event);
        closeMenu();
    };

    const confirmExit = () => {
        if (onInteraction) onInteraction("exit");
    };

    const hp = getEntityProp(currentPlayer, "hp");
    const hpMax = getEntityProp(currentPlayer, "params.maxHp");
    const sp = getEntityProp(currentPlayer, "sp");
    const spMax = getEntityProp(currentPlayer, "params.maxSp");
    const level = getEntityProp(currentPlayer, "level");
    const exp = getEntityProp(currentPlayer, "exp");
    const gold = getEntityProp(currentPlayer, "gold");
    const heroName = getEntityProp(currentPlayer, "name");
    const heroGraphic = computed(() => currentPlayer()?.graphicsSignals?.()?.[0]);
    const heroSheet = () => ({ definition: heroGraphic(), params: { direction: Direction.Down } });
    const expForNextlevel = computed(() => data().expForNextlevel || 0);
    const hpPercent = computed(() => {
        const max = hpMax() || 1;
        return `${Math.max(0, Math.min(100, (hp() / max) * 100))}%`;
    });
    const spPercent = computed(() => {
        const max = spMax() || 1;
        return `${Math.max(0, Math.min(100, (sp() / max) * 100))}%`;
    });
    const expPercent = computed(() => {
        const max = expForNextlevel() || 1;
        return `${Math.max(0, Math.min(100, (exp() / max) * 100))}%`;
    });

    const paramsList = computed(() => {
        return [
            { label: t("rpg.stat.atk"), value: data().playerStats.atk },
            { label: t("rpg.stat.pdef"), value: data().playerStats.pdef },
            { label: t("rpg.stat.sdef"), value: data().playerStats.sdef },
            { label: t("rpg.stat.str"), value: data().playerStats.str },
            { label: t("rpg.stat.dex"), value: data().playerStats.dex },
            { label: t("rpg.stat.int"), value: data().playerStats.int },
            { label: t("rpg.stat.agi"), value: data().playerStats.agi }
        ]
    });

    const menuControls = signal({
        up: {
            repeat: true,
            bind: keyboardControls.up,
            throttle: 150,
            keyDown() {
                if (saveOverlay() || hotbarAssignmentOpen()) return;
                if (view() !== "menu") return;
                moveMenu(-1);
            }
        },
        down: {
            repeat: true,
            bind: keyboardControls.down,
            throttle: 150,
            keyDown() {
                if (saveOverlay() || hotbarAssignmentOpen()) return;
                if (view() !== "menu") return;
                moveMenu(1);
            }
        },
        action: {
            bind: getKeyboardControlBind(keyboardControls.action),
            keyDown() {
                if (saveOverlay() || hotbarAssignmentOpen()) return;
                if (view() !== "menu") return;
                openMenu();
            }
        },
        tabPrev: {
            bind: "page up",
            keyDown() {
                switchTab(-1);
            }
        },
        tabNext: {
            bind: "page down",
            keyDown() {
                switchTab(1);
            }
        },
        escape: {
            bind: keyboardControls.escape,
            keyDown() {
                if (saveOverlay()) return;
                if (hotbarAssignmentOpen()) {
                    closeHotbarAssignment();
                    return;
                }
                if (view() !== "menu") {
                    goBack();
                    return;
                }
                closeMenu()
            }
        },
        gamepad: menuGamepadControls
    });

    mount((element) => {
        const bindingsSubscription = effect(() => {
            refreshKeyboardBindings(element.directives.controls, movementPreferences(engine).bindings());
        }).subscription;
        engine.playUiSound("open");
        const inputLockToken = {};
        const previousGamePause = engine.gamePause();
        engine.__rpgMainMenuInputLock = inputLockToken;
        engine.stopProcessingInput = true;
        engine.gamePause.set(true);
        return () => {
            transition.dispose();
            releaseInput();
            bindingsSubscription.subscription?.unsubscribe?.();
            bindingsSubscription.unsubscribe?.();
            delay(() => {
                if (engine.__rpgMainMenuInputLock !== inputLockToken) return;
                engine.__rpgMainMenuInputLock = undefined;
                engine.gamePause.set(previousGamePause);
            });
        }
    });
</script>
